export default function About() {
  return (
    <section id="about" className="py-32 px-6 bg-gradient-to-b from-black to-zinc-950">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold mb-8">
            <strong>Built for Operators</strong>
          </h2>
        </div>

        <div className="bg-zinc-900/50 border border-zinc-800 p-12 rounded-lg">
          <p className="text-xl text-gray-300 leading-relaxed mb-8">
            MR Prime Ops is the partner for leaders who prefer results over noise. We install systems that hold under pressure and scale without drama.
          </p>
          
          <div className="grid md:grid-cols-3 gap-8 mt-12 pt-12 border-t border-zinc-800">
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-cyan-500/10 rounded-lg mb-4 mx-auto">
                <i className="ri-focus-3-line text-3xl text-cyan-400"></i>
              </div>
              <h3 className="text-lg font-bold mb-2">Precision Focus</h3>
              <p className="text-sm text-gray-400">
                We solve operational problems, not symptoms
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-cyan-500/10 rounded-lg mb-4 mx-auto">
                <i className="ri-lock-2-line text-3xl text-cyan-400"></i>
              </div>
              <h3 className="text-lg font-bold mb-2">Discreet Execution</h3>
              <p className="text-sm text-gray-400">
                Your operations, your confidentiality
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-cyan-500/10 rounded-lg mb-4 mx-auto">
                <i className="ri-trophy-line text-3xl text-cyan-400"></i>
              </div>
              <h3 className="text-lg font-bold mb-2">Proven Systems</h3>
              <p className="text-sm text-gray-400">
                Battle-tested frameworks that scale
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
